var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

import { combineReducers } from 'redux';
import * as actions from '../actions';
import Texto from '../texto';

var modoCrear = function modoCrear() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments[1];

  switch (action.type) {
    case actions.TEXTO_MODO_CREAR:
      return action.modo;

    case actions.TEXTO_CREAR:
      return false;

    default:
      return state;
  }
};

var esTextoDePagina = function esTextoDePagina(texto) {
  return !texto.numZona;
};

var haPasadoAPaginaIzquierda = function haPasadoAPaginaIzquierda(texto) {
  return texto.x < 0;
};

var haPasadoAPaginaDerecha = function haPasadoAPaginaDerecha(texto) {
  return texto.x >= 100;
};

var textos = function textos() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var action = arguments[1];

  switch (action.type) {
    case actions.TEXTOS_ELIMINAR:
      return state.filter(function (texto) {
        return !(texto.libroId === action.libroId && texto.numPagina === action.numPagina && Number(texto.numZona) === Number(action.numZona));
      });

    case actions.TEXTO_ACTUALIZAR:
      return state.map(function (texto) {
        if (texto.id !== action.textoId) {
          return texto;
        }

        var textoActualizado = _extends({}, texto, action.valores);

        if (esTextoDePagina(textoActualizado)) {
          if (haPasadoAPaginaIzquierda(textoActualizado)) {
            textoActualizado.x += 100;
            textoActualizado.numPagina -= 1;
          } else if (haPasadoAPaginaDerecha(textoActualizado)) {
            textoActualizado.x -= 100;
            textoActualizado.numPagina += 1;
          }
        }

        return textoActualizado;
      }).filter(function (texto) {
        return !Texto.esVacio(texto.textoHtml);
      });

    case actions.TEXTO_CREAR:
      return [].concat(state, [action.texto]);

    case actions.TEXTOS_CARGAR:
      return action.textos;

    default:
      return state;
  }
};

var textosUsuario = combineReducers({
  modoCrear: modoCrear,
  textos: textos
});
export default textosUsuario;